import { render } from "./BotDiscovery.vue?vue&type=template&id=1196f869&scoped=true"
import script from "./BotDiscovery.vue?vue&type=script&lang=js"
export * from "./BotDiscovery.vue?vue&type=script&lang=js"

import "./BotDiscovery.vue?vue&type=style&index=0&id=1196f869&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1196f869"]])

export default __exports__